export const BRAND = {
  name: "Vinconex",
  owner: "CraveBeast LLC",   // platform owner / operator on every surface
  tagline: "Scan. Connect. Drive Sales.",
  phone: "570-445-5190",
  phoneHref: "tel:+15704455190",
  logo: "/brand/vinconex-logo.png",
  mark: "/brand/vinconex-mark.png",
  wordmark: "/brand/vinconex-wordmark.png",
  blue: "#0A8CF2",
};

// Vinconex staff console lives on its own domain; dealers & shoppers use vinconex.com
export const ADMIN_HOST = "www.vinconex.net";
export const DEALER_HOST = "www.vinconex.com";
const host = () => (typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "");
export const isAdminHost = () => /(^|\.)vinconex\.net$/.test(host());
export const isDealerHost = () => /(^|\.)vinconex\.com$/.test(host());
// On the production dealer site the staff link crosses to www.vinconex.net; everywhere else (preview, the admin host) it's the local /admin route
export const adminHref = () => (isDealerHost() ? `https://${ADMIN_HOST}` : "/admin");
// Mirror image: from the staff domain, dealers are sent back to the dealer site; anywhere else stay local
export const dealerHref = (path = "/") => (isAdminHost() ? `https://${DEALER_HOST}${path}` : path);
export const adminLabel = () => (isDealerHost() || isAdminHost() ? ADMIN_HOST : "/admin");

export function hexToRgb(hex) {
  const h = (hex || "").replace("#", "").trim();
  const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  if (!/^[0-9a-f]{6}$/i.test(full)) return null;
  return [0, 2, 4].map((i) => parseInt(full.slice(i, i + 2), 16));
}

export function brandStyle(accent) {
  const rgb = hexToRgb(accent) || hexToRgb(BRAND.blue);
  const soft = rgb.map((c) => Math.round(c + (255 - c) * 0.45));
  return { "--brand-rgb": rgb.join(" "), "--brand-soft-rgb": soft.join(" ") };
}
